import React from "react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { DollarSign, FileText } from "lucide-react";
import { ServiceData } from "@/interface/entityInterface";
import { Sheet } from "@/interface/dataInterface";
import VehicleCard from "../components/VehicleCard";
import DateAndOdometer from "../components/DateAndOdometer";
import CommonDetailsSheet from "@/components/common/details/DetailsSheet";
import CommonDetailsDialog from "@/components/common/details/DetailsDialog";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table";
import { format } from "date-fns";

interface ServiceDetailsSheetProps extends Sheet {
  service: ServiceData | null;
}

export const ServiceDetails: React.FC<ServiceDetailsSheetProps> = ({
  service,
  open,
  setOpen,
}) => {
  if (!service) return null;

  const totalAmount = service.service_type_values.reduce(
    (sum, item) => sum + item.value,
    0,
  );

  return (
    <CommonDetailsDialog open={open} setOpen={setOpen} title='service details' description={`Total breakdown of service # ${service.id}`}>
            <div className="w-full max-w-2xl mx-auto bg-background shadow-md overflow-hidden sm:rounded-lg">
          <div className="px-6 py-4 space-y-6">
            <div className="flex justify-between">
              <VehicleCard vehicle={service.vehicle}/>
              <div className="text-right">
                <p className="text-sm text-gray-600 dark:text-gray-400">{format(service.date, "dd MMMM yyyy HH:mm")}</p>
                <p className="text-sm text-gray-600 dark:text-gray-400">{service.odometer} km</p>
              </div>
            </div>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Name</TableHead>
                  <TableHead>Price</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {service.service_type_values.length > 0 && service.service_type_values.map(item => (
                  <TableRow key={item.id}>
                    <TableCell>{item.service_type.name}</TableCell>
                    <TableCell>${item.value}</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                    <TableCell>Total</TableCell>
                    <TableCell>${totalAmount}</TableCell>
                  </TableRow>
              </TableBody>
            </Table>
            <div>
              {service.notes}
            </div>
          </div>
        </div>
        </CommonDetailsDialog>
  );
};
